"use strict";
import SiteTemplate from 'SiteTemplate';
import ProductListItemCollection from "components/ProductListItemCollection";

export default class AbstractPage {
    constructor() {
        this.site = new SiteTemplate();
        this.productListItemCollection = new ProductListItemCollection;
    }
}